import { Box } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import { CrudAction } from 'enums/tables';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { VideosService } from 'services/videos.service';
import { STATIC_PREFIX, useVideosStore } from 'stores/use-videos-store';

// only used for confirming a delete video(s) action
export const VideosCrudDialog = () => {
  const dialogCRUD = useVideosStore((s) => s.dialogCRUD);

  if (
    dialogCRUD &&
    dialogCRUD.action === CrudAction.Delete &&
    dialogCRUD.models.length > 0
  ) {
    return (
      <CommonConfirmationDialog
        key={dialogCRUD.key}
        identifier="VideoLibraryDeleteDialog"
        maxWidth={RADIX.DIALOG.WIDTH.MD}
        title={t('common.delete-x', {
          x: t(
            dialogCRUD.models.length === 1 ? 'videos.video' : 'videos.videos'
          ),
        }).toString()}
        content={
          <Box>
            <p>
              {t('common.confirm-remove-n-x', {
                n: dialogCRUD.models.length,
                x: t(
                  dialogCRUD.models.length === 1
                    ? 'videos.video'
                    : 'videos.videos'
                ),
              })}
            </p>
            <ul>
              {dialogCRUD.models.map((v) => (
                <li key={`del-video-${v._id}`}>
                  {v.VideoTitle || v.VideoFileName}
                </li>
              ))}
            </ul>
            <p>{t('videos.orphaned-pitches-warning')}</p>
          </Box>
        }
        action={{
          label: 'common.delete',
          color: RADIX.COLOR.DANGER,
          onClick: async () => {
            try {
              useVideosStore.setState({ loading: true });

              const safeIDs = dialogCRUD.models
                .filter((v) => !v.video_path.startsWith(STATIC_PREFIX))
                .map((v) => v._id);

              const result =
                await VideosService.getInstance().deleteMany(safeIDs);

              if (!result.success) {
                throw new Error(result.error);
              }

              useVideosStore.setState({ dialogCRUD: undefined });
              dialogCRUD.onClose?.();

              NotifyHelper.success({
                message_md: t('common.x-deleted-successfully', {
                  x:
                    safeIDs.length === 1
                      ? t('videos.video')
                      : t('videos.videos'),
                }),
              });

              /** remove video(s) from store after the dialog has closed */
              setTimeout(() => {
                useVideosStore.setState((s) => ({
                  videos: s.videos.filter((v) => !safeIDs.includes(v._id)),
                  // ? de-select the video if it was deleted
                  selectedVideo: s.videos.find(
                    (v) => v._id === s.selectedVideo?._id
                  ),
                }));
              }, 500);

              return true;
            } catch (e) {
              console.error(e);

              NotifyHelper.error({
                message_md: t('common.request-failed-msg'),
              });

              return false;
            } finally {
              useVideosStore.setState({ loading: false });
            }
          },
        }}
      />
    );
  }

  return null;
};
